module.exports = __webpack_public_path__ + "img/project2_small@2x.ee698784.jpg";